import { Alert, Button, CloseButton, Divider, Flex, Grid, LoadingOverlay, Text } from "@mantine/core";
import React from "react";
import * as yup from "yup";
import { AuthApi, LbfProductApi } from "../../apis";
import HttpHandler from "../../utils/http-handler";
import { Message } from "../../utils/message";
import { Form } from "../form";
import { OtpField } from "../form/otp-field";
import { TextareaField } from "../form/textarea-field";
import { FormLayout } from "../layout";

const schema = yup.object({
  pin: yup.string().min(6, "Заавал бөглөнө!").required("Заавал бөглөнө!").nullable(),
});

type IFormData = {
  pin: string;
  reviewDesc: string;
  review: boolean;
};

export function ProductBuyerLedContorForm({
  onSuccess,
  subTitle,
  title,
  onClose,
  action,
}: {
  onClose: () => void;
  onSuccess: () => void;
  subTitle: string;
  title: string;
  action: any;
}) {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [type, setType] = React.useState<boolean>(false);
  const [data] = React.useState<IFormData>({
    pin: "",
    reviewDesc: "",
    review: false,
  });

  const onSubmit = async (data: IFormData) => {
    setLoading(true);

    try {
      await AuthApi.checkPin({ pin: data.pin });

      await LbfProductApi.review(action && action[1]?.id, {
        review: type,
        reviewDesc: data.reviewDesc,
      });

      if (type) {
        Message.success("Та бүтээгдэхүүнийг амжилттай хянасан.");
      } else {
        Message.success("Та бүтээгдэхүүнийг амжилттай татгалзсан.");
      }
      onSuccess();
    } catch (err) {
      Message.error((err as HttpHandler)?.message!);
    }
    setLoading(false);
  };

  return (
    <Form validationSchema={schema} onSubmit={onSubmit} initialValues={data}>
      {({ setFieldValue }) => {
        return (
          <FormLayout title={title} subTitle={subTitle} my={0} extra={[<CloseButton key="cancel" onClick={() => onClose()} />]}>
            <LoadingOverlay visible={loading} />
            <Grid>
              <Grid.Col span={12}>
                <Divider />
              </Grid.Col>

              <Grid.Col span={12}>
                <Alert
                  styles={{ message: { color: "#44566c", fontWeight: 500 } }}
                  radius="md"
                  color="indigo"
                  withCloseButton={false}
                  title="Бүтээгдэхүүний мэдээлэл">
                  {`Та ${action && action[1]?.refCode} кодтой зээлийн лимит суурьтайгаа олгох санхүүжилтийн бүтээгдэхүүнийг хянах гэж байна.`}
                </Alert>
              </Grid.Col>

              <Grid.Col span={12}>
                <TextareaField
                  name="reviewDesc"
                  label="Тайлбар, коммент бичих бол энд бичнэ үү"
                  placeholder="Тайлбар оруулах..."
                  withAsterisk={false}
                  maxLength={255}
                />
              </Grid.Col>

              <Grid.Col span={12}>
                <OtpField name="pin" label="Үйлдлийг баталгаажуулах бол ПИН кодоо оруулна уу." placeholder="" required />
              </Grid.Col>
              <Grid.Col span={12}>
                <Text component="p" fz="sm" fw={500}>
                  Танд амжилт хүсье!
                </Text>
              </Grid.Col>
              <Grid.Col span={12}>
                <Divider />
              </Grid.Col>
            </Grid>
            <Flex mt={20} direction="row" justify="space-between">
              <Button variant="default" onClick={() => onClose()}>
                Болих
              </Button>
              <Flex gap="md">
                <Button variant="outline" type="submit" onClick={() => setType(false)} color="red">
                  Татгалзах
                </Button>
                <Button variant="filled" type="submit" onClick={() => setType(true)}>
                  Хянасан
                </Button>
              </Flex>
            </Flex>
          </FormLayout>
        );
      }}
    </Form>
  );
}
